module.exports = __webpack_public_path__ + "static/img/passion.a2134c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/passion.jpg
// module id = UQ1I
// module chunks = 1